import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@components/Badge';
import { Box } from '@components/Box';
import { Modal } from '@components/Modal';
import { Row } from '@components/Row';
import { Stack } from '@components/Stack';
import { Text } from '@components/Text';

type VideoScreeningModalProps = {
  isModalOpen: boolean;
  closeModal: () => void;
  company: string;
  videoUid: string;
  applicationId: string;
  testID?: string;
  applicantName: string;
  videoQuestion?: string;
};

export const VideoScreeningModal = ({
  isModalOpen,
  closeModal,
  company,
  videoUid: _videoUid,
  applicationId: _applicationId,
  testID,
  applicantName,
  videoQuestion
}: VideoScreeningModalProps) => {
  const { t } = useTranslation();

  const titleWithBetaBadge = (
    <Row tone="transparent" spacing="small" flexWrap="wrap">
      <Box tone="transparent" marginBottom="xxsmall">
        <Text weight="bold">
          {t('applications.applicationCard.screeningVideo.title', {
            name: applicantName
          })}
        </Text>
      </Box>

      <Box tone="transparent" marginBottom="xxsmall">
        <Badge tone="promo">{t('badge.beta')}</Badge>
      </Box>
    </Row>
  );

  return (
    <Modal
      testID={testID}
      title={titleWithBetaBadge}
      visible={isModalOpen}
      onRequestClose={closeModal}
    >
      <Stack spacing="medium" width="full" height="full">
        <Text size="small">
          {videoQuestion ||
            t('applications.applicationCard.screeningAnswer.label', {
              businessName: company
            })}
        </Text>
      </Stack>
    </Modal>
  );
};
